
import {initActions} from '@dized/ui/dist/redux/ActionHelper';
import {genericActions} from '@dized/ui/dist/redux/OrmHelper';
import {post} from '@dized/ui/dist/redux/RequestHelper';

const path = '/api/v1/user/Users';
const apiPath = '/api/v1/user/users';
const modelName = 'USER';

export default initActions('OrganizationActions', {
  ...genericActions({modelName}, apiPath),
  CREATE_TEST_ORGANIZATION: name => post(`${path}/testOrganization`, {name}),
  LOGIN: credentials => post(`${path}/login`, {
    'email': credentials.username,
    'password': credentials.password
  }),
  LOGOUT: () => post(`${path}/logout`),
  POST_REGISTER: data => post(`${path}/register`, data),
});